import React from 'react';

import Avatar from '@atlaskit/avatar';

const AvatarDefaultExample = (): React.JSX.Element => {
	return <Avatar />;
};

export default AvatarDefaultExample;
